module.exports = __webpack_public_path__ + "static/media/icono_bar_menu-mobile.82f63f05.webp";